import styled from 'styled-components';
import colors from '../../constants/colors';

const ErrorMessage = styled.div`
    color: ${colors.red};
    font-size: 12px;
`;

export default ErrorMessage;
